import template from './rooms-count-daily.jade';
import validation from './../../../services/validation';
import roomsCount from './../../../enums/rooms-count';

import { initializeSegmentInputTooltips } from '../../../utils/segment-input-tooltips';

export default angular
  .module('cian.addForm.roomsCountDaily', [])
  .directive('cianAfAboutObjectRoomsCountDaily', () => ({
    scope: {},
    bindToController: {
        ad: '=',
        form: '=',
    },
    controller: ['$scope', 'adTooltipsService', 'analyticsService', 'deviceService', 'popupService', function ($scope, adTooltipsService, analyticsService, deviceService, popupService) {
      this.isMobile = deviceService.isMobile;
      this.modalHintTitle = 'Количество комнат';
      this.tooltipText = '';
      const getSelectedRoomsCountOption = () => {
        if (this.ad.flatType === 'rooms') {
          return this.ad.roomsCount;
        }
        return this.ad.flatType;
      };

      const getServerValues = () => {
        if (this.selectedRoomsCountOption === 'openPlan') {
          return ['openPlan', undefined];
        } else if (this.selectedRoomsCountOption === 'studio') {
          return ['studio', undefined];
        }
        return ['rooms', this.selectedRoomsCountOption];
      };

      this.roomsCountOptions = roomsCount;

      this.selectedRoomsCountOption = getSelectedRoomsCountOption();

      this.validation = validation(this.form, 'roomsCount', {
        required: 'Выберите значение',
      });

      this.onChange = () => {
        [this.ad.flatType, this.ad.roomsCount] = getServerValues();
      };

      initializeSegmentInputTooltips({
        controller: this,
        $scope,
        adTooltipsService,
        adAnalyticsCategory: analyticsService.adAnalyticsCategory,
        tooltipsKey: 'roomsCount',
        trackingLabel: 'rooms-count-daily-hint',
        popupService,
        isMobile: this.isMobile,
      });
    }],
    controllerAs: 'roomsCountDaily',
    template,
  }))
  .name;
